import { driveCreativesCopy as t } from "./copy.ts";

export const steps = { drive: t.passo };
